import { AppBar, Container, Stack } from "@mui/material";
import { Outlet } from "react-router-dom";
import OnboardingNavBar from "src/components/NavBars/OnboardingNavBar/OnboardingNavBar";
import CancellationModalProvider from "src/context/CancellationModalProvider";
import { useSubscription } from "src/context/SubscriptionProvider";
import CompleteCancellationModal from "src/pages/Questions/components/QuestionBody/components/Cancellation/CompleteCancellationModal";

const CancellationLayout = () => {
  const subscriptionId = useSubscription((s) => s.id);

  return (
    <CancellationModalProvider subscriptionId={subscriptionId!}>
      <Stack>
        <AppBar
          position="fixed"
          sx={{
            width: `100%`,
            boxShadow: "none",
            backgroundColor: "#ffffff",
            color: "#000000",
          }}
        >
          <Stack spacing={1}>
            <OnboardingNavBar visitType={"Cancellation"} hasNoProgressBar />
          </Stack>
        </AppBar>
        <Container
          disableGutters
          maxWidth="sm"
          sx={{
            flexGrow: 1,
            p: 2,
            mt: 12,
          }}
        >
          <Outlet />
        </Container>
        <CompleteCancellationModal />
      </Stack>
    </CancellationModalProvider>
  );
};

export default CancellationLayout;
